import { swalMessage } from '@components/common';

const DEFAULT_ERROR_MESSAGE = '요청 처리 중 오류가 발생했습니다.\n잠시 후 다시 시도해 주세요.';

const parseToJsonString = (content: any) => {
  try {
    if (typeof content === 'string') return content;
    if (!content || (typeof content === 'object' && Object.keys(content).length === 0)) return undefined;
    const stringified = JSON.stringify(content);
    return stringified;
  } catch (error) {
    return undefined;
  }
};

const findMessageInObject = (content: any): string | undefined => {
  if (!content) return undefined;
  if (typeof content === 'string') return content;
  if (Array.isArray(content)) {
    const messages = content
      .map((item) => findMessageInObject(item))
      .filter((message): message is string => !!message);
    return messages.length > 0 ? messages.join('\n') : undefined;
  }
  if (typeof content !== 'object') return undefined;

  const candidateKeys = ['modalMessage', 'message', 'error', 'detail', 'details', 'reason'];
  for (const key of candidateKeys) {
    const value = content[key];
    if (typeof value === 'string' && value.trim()) return value;
    const nestedMessage = findMessageInObject(value);
    if (nestedMessage) return nestedMessage;
  }

  return parseToJsonString(content);
};

export const createErrorMessage = (error: any, fallbackErrorMessage?: string) => {
  try {
    const response = error?.response || error;
    const status = response?.status;
    const data = response?.data;
    const responseMessage = findMessageInObject(data);

    if (status) {
      const message = responseMessage || findMessageInObject(response?.message) || fallbackErrorMessage;
      return `잘못된 요청입니다. 잠시 후 다시 시도해 주세요.\n문제가 계속 발생하는 경우 관리자에게 문의해 주세요.\n\n${
        message || DEFAULT_ERROR_MESSAGE
      }`;
    }

    const message = findMessageInObject(error?.message);
    if (message)
      return `웹 페이지에서 처리되지 않은 오류가 발생했습니다.\n관리자에게 문의해 주세요.\n\n오류 정보: ${message}`;

    return fallbackErrorMessage || findMessageInObject(error) || DEFAULT_ERROR_MESSAGE;
  } catch (caughtError) {
    return fallbackErrorMessage || findMessageInObject(caughtError) || DEFAULT_ERROR_MESSAGE;
  }
};

const useHandleError = () => {
  const catchError = (error: any, fallbackErrorMessage?: string, onClose?: () => void) => {
    const errorMessage = createErrorMessage(error, fallbackErrorMessage);
    const onConfirmAndCancel = () => {
      if (!onClose) return;
      onClose();
    };
    swalMessage('error', errorMessage, '확인', false, onConfirmAndCancel, onConfirmAndCancel);
  };

  return { catchError };
};

export default useHandleError;
